import DonationProjectsList from "./DonationProjectsList";

export default function OurProjects({ language = "en" }) {
  return <DonationProjectsList type="Project" language={language} />;
}
